<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { computed } from "vue";

const props = defineProps<{ modelValue?: string; separator: string }>();
const items = computed(() =>
  props.modelValue ? props.modelValue.split(props.separator) : []
);
</script>
<template>
  <div class="mp-tags">
    <nut-tag v-for="(item, index) in items" :key="index" v-bind="$attrs">
      {{ item }}
    </nut-tag>
  </div>
</template>
<style lang="scss">
.mp-tags {
  display: inline-flex;
  flex-wrap: wrap;
  .nut-tag {
    margin: 0 5px 5px 0;
  }
}
</style>
